<template>
  <component :is="tag" :class="[className]">
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    tag: { default: 'p', type: String },

    // Color variants
    lightGray: Boolean,
    gray: Boolean,
    darkGray: Boolean,
    lightNavy: Boolean,
    navy: Boolean,
    darkNavy: Boolean,
    black: Boolean,
    white: Boolean,
    red: Boolean,

    // Font variants
    sizeXxxl: Boolean,
    sizeXxl: Boolean,
    sizeXl: Boolean,
    sizeLg: Boolean,
    sizeBase: Boolean,
    sizeSm: Boolean,
    sizeXs: Boolean,

    // Leading variants
    leadTight: Boolean,
    leadRegular: Boolean,
    leadLoose: Boolean,

    // Modifiers
    bold: Boolean,
    center: Boolean,
    ellipsis: Boolean,
    italic: Boolean,
    medium: Boolean,
    underline: Boolean,
    uppercase: Boolean,
  },

  computed: {
    className() {
      return [
        this.lightGray && this.lightGrayClass,
        this.gray && this.grayClass,
        this.darkGray && this.darkGrayClass,
        this.lightNavy && this.lightNavyClass,
        this.navy && this.navyClass,
        this.darkNavy && this.darkNavyClass,
        this.black && this.blackClass,
        this.white && this.whiteClass,
        this.red && this.redClass,

        this.sizeXxxl && this.sizeXxxlClass,
        this.sizeXxl && this.sizeXxlClass,
        this.sizeXl && this.sizeXlClass,
        this.sizeLg && this.sizeLgClass,
        this.sizeBase && this.sizeBaseClass,
        this.sizeSm && this.sizeSmClass,
        this.sizeXs && this.sizeXsClass,

        this.leadTight && this.leadTightClass,
        this.leadRegular && this.leadRegularClass,
        this.leadLoose && this.leadLooseClass,

        this.bold && this.boldClass,
        this.center && this.centerClass,
        this.ellipsis && this.ellipsisClass,
        this.italic && this.italicClass,
        this.medium && this.mediumClass,
        this.underline && this.underlineClass,
        this.uppercase && this.uppercaseClass,
      ];
    },
  },

  data: () => ({
    // Color classes
    lightGrayClass: 'text-gray-500',
    grayClass: 'text-gray-700',
    darkGrayClass: 'text-gray-900',
    lightNavyClass: 'text-navy-400',
    navyClass: 'text-navy-500',
    darkNavyClass: 'text-navy-700',
    blackClass: 'text-black',
    whiteClass: 'text-white',
    redClass: 'text-red-600',

    // Font classes
    sizeXxxlClass: 'text-4xl lg:text-5xl',
    sizeXxlClass: 'text-2xl lg:text-3xl',
    sizeXlClass: 'text-xl lg:text-2xl',
    sizeLgClass: 'text-lg',
    sizeBaseClass: 'text-base',
    sizeSmClass: 'text-sm',
    sizeXsClass: 'text-2xs',

    // Leading classes
    leadTightClass: 'leading-tight',
    leadRegularClass: 'leading-normal',
    leadLooseClass: 'leading-relaxed',

    // Variant classes
    boldClass: 'font-bold',
    centerClass: 'text-center',
    ellipsisClass: 'whitespace-nowrap overflow-hidden overflow-ellipsis',
    italicClass: 'font-italic',
    mediumClass: 'font-medium',
    underlineClass: 'underline',
    uppercaseClass: 'uppercase',
  }),
};
</script>
